import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import theme from './theme/theme';
import Layout from './components/Layout';
import PublicLayout from './components/PublicLayout';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Setup from './pages/Setup';
import Dashboard from './pages/Dashboard';
import TrailProgress from './pages/TrailProgress';
import Devotionals from './pages/Devotionals';
import EditTrail from './pages/EditTrail';
import TrailDevotionals from './pages/TrailDevotionals';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ExploreTrails from './pages/ExploreTrails';
import ViewTrail from './pages/ViewTrail';
import Checkout from './pages/Checkout';
import Comments from './pages/Comments';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public Routes - Explore pages */}
            <Route
              path="/explore"
              element={
                <PublicLayout>
                  <ExploreTrails />
                </PublicLayout>
              }
            />
            <Route
              path="/explore/:id"
              element={
                <PublicLayout>
                  <ViewTrail />
                </PublicLayout>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <PublicLayout>
                    <Profile />
                  </PublicLayout>
                </PrivateRoute>
              }
            />

            {/* Auth Routes */}
            <Route path="/setup" element={<Setup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacidade" element={<PrivacyPolicy />} />
            <Route path="/termos" element={<TermsOfService />} />
            <Route path="/checkout" element={<Checkout />} />

            {/* Admin Routes */}
            <Route
              path="/"
              element={
                <AdminRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </AdminRoute>
              }
            />
            <Route
              path="/progress"
              element={
                <AdminRoute>
                  <Layout>
                    <TrailProgress />
                  </Layout>
                </AdminRoute>
              }
            />
            <Route
              path="/devotionals"
              element={
                <AdminRoute>
                  <Layout>
                    <Devotionals />
                  </Layout>
                </AdminRoute>
              }
            />
            <Route
              path="/trails/new"
              element={
                <AdminRoute>
                  <Layout>
                    <EditTrail />
                  </Layout>
                </AdminRoute>
              }
            />
            <Route
              path="/trails/:id/edit"
              element={
                <AdminRoute>
                  <Layout>
                    <EditTrail />
                  </Layout>
                </AdminRoute>
              }
            />
            <Route
              path="/trails/:id/devotionals"
              element={
                <AdminRoute>
                  <Layout>
                    <TrailDevotionals />
                  </Layout>
                </AdminRoute>
              }
            />
            <Route
              path="/users"
              element={
                <AdminRoute>
                  <Layout>
                    <Users />
                  </Layout>
                </AdminRoute>
              }
            />
            <Route
              path="/comments"
              element={
                <AdminRoute>
                  <Layout>
                    <Comments />
                  </Layout>
                </AdminRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <AdminRoute>
                  <Layout>
                    <Settings />
                  </Layout>
                </AdminRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
